module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-cactus006htmlacknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/pppcactus005#ppp-cactus005htmltoc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Paying my debts: The retired Phoenix Police officers of the Big Apple breakfast club, especially Glenn Martin, provided valuable insights into law enforcement in the 1940s. The Phoenix Police Museum helped me see and touch the era. Any errors or deliberate changes in descriptions or procedures are my responsibility.")]), _vm._v(" "), _c('p', [_vm._v("Retired Phoenix officers Steve Fotinos and Cal Lash, along with retired Mesa detective Bill Richardson, have regaled me with stories of Arizona law enforcement history, which inform this and future Mapstone novels.")]), _vm._v(" "), _c('p', [_vm._v("Also, I’m grateful to Jana Bommersbach for her path-breaking work on the Winnie Ruth Judd case, which provides a window into the often sleazy workings of old Phoenix. Bill Stephens, a legendary Arizona lawyer,  was generous in his memories of the city. Dr. Jack August, Jr., the director of the Arizona Historical Foundation, continues to inspire me with what a real-life historian can accomplish.")]), _vm._v(" "), _c('p', [_vm._v("Finally, I give special thanks to Barbara Peters, my editor, who in no small measure made "), _c('em', [_vm._v("Cactus Heart")]), _vm._v(" possible.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27dfa405","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-cactus006.vue
// module id = 72
// module chunks = 0